
export const INPUT_TYPE = {
    "TEXT" : "TEXT",
    "TIME" : "TIME",
    "NUMBER" : "NUMBER",
    "SELECT" : "SELECT",
    "LIST" : "LIST",
    "DATES" : "DATES"
}

export const HTML_INPUT_TYPE_KEY = {
    [INPUT_TYPE.TEXT] : "text",
    [INPUT_TYPE.TIME] : "time",
}